export default function progressBarDirective(EcourseFactory){
  'ngInject';
  return {
    restrict: 'E',
    templateUrl: 'app/ecourse/shared/progressBar/progressBar.html',
    scope: {
      progress: '='
    },
    link: function($scope){
      $scope.progressPercentage = function(segment){
        let {percentage} = EcourseFactory.segmentProgress(segment);
        return percentage;
      };
    }
  };
}



/** WEBPACK FOOTER **
 ** ./src/app/ecourse/shared/progressBar/progressBar.directive.js
 **/